export const ROUTES_NAME = ['/'];

export const FOOTER_CONTENT =
  "TradingValley Inc., California corporate number: C4098652 is an SEC registered online advisor (801-114112) CRD number is 298542. Brokerage services provided to clients of Growin by Interactive Brokers, an SEC-registered broker-dealer and member of FINRA /SIPC. Investments in securities including but not limited to stocks, ETFs: Not FDIC Insured • No Bank Guarantee • May Lose Value. Investing in securities involves risks, and there is always the potential of losing principle you invested. Before investing, consider your investment objectives, financial situation and Growin's charges and expenses. Growin's advisory services are designed to assist clients in achieving discrete financial goals. They are not intended to provide comprehensive tax advice or financial planning with respect to every aspect of a client's financial situation. For more details, see our Form ADV and other disclosures. Past performance does not guarantee future results, and the likelihood of investment outcomes are hypothetical in nature. © 2019 TradingValley Inc. All rights reserved.";

export const META_INFO = [
  {
    title: 'Growin - 讓您的資產聰明成長',
    description:
      'Growin 透過先進科技打開您資產成長的最大潛力，不論您想規劃退休、累積子女教育基金、計畫買房或旅遊，由 Growin 時時刻刻為您做最好的投資決策，讓您有更多的時間享受生活、追逐夢想。',
  },
  {
    title: 'Growin - 投資組合',
    description:
      '我們以 ETF 資產配置為核心，搭配積極型的智能選股策略，讓您投資的每分錢發揮最大效益，不只為您分散投資風險，當發掘市場的起漲訊號，也讓您積極參與股市成長。',
  },
  {
    title: 'Growin - 演算法技術',
    description:
      '我們運用機器學習與量化投資演算法，分析上萬檔的投資標的，於全球市場上挖掘投資機會，並打造兼顧成長與風險分散的投資策略，讓您的資產穩健成長。',
  },
  {
    title: 'Growin - 聯絡我們',
    description:
      '需要協助嗎？不論您有任何問題或是對我們的建議，歡迎隨時透過我們的線上表格與我們聯繫。',
  },
  {
    title: 'Growin - 訂閱最新消息',
    description:
      '想要知道 Growin 的最新消息嗎？不論是 Growin 產品的新功能、Blog 文章、 影片、新聞及相關活動都能隨時掌握喔。',
  },
];
